// Web-only Firebase config for React Native Web
import { initializeApp, getApps } from 'firebase/app';
import {
  getAuth,
  signInWithEmailAndPassword,
  sendPasswordResetEmail as sendPasswordResetEmailModular,
  EmailAuthProvider,
  updateEmail,
  updatePassword,
  reauthenticateWithCredential,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';


const firebaseConfig = {
  apiKey: 'AIzaSyDOS29C7f1vNbE88V-bMci3SH9nNMbXngY',
  authDomain: 'goalmint-d68e6.firebaseapp.com',
  projectId: 'goalmint-d68e6',
  storageBucket: 'goalmint-d68e6.appspot.com',
  messagingSenderId: '613664947527',
  appId: '1:613664947527:web:20a71aa9632cb0c7f86062',
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

const authInstance = getAuth(app);
const firestoreInstance = getFirestore(app);

// Cross-platform signOut for web
const signOut = async () => {
  return authInstance.signOut();
};

const signInWithEmailAndPasswordWeb = async (email: string, password: string) => {
  return signInWithEmailAndPassword(authInstance, email, password);
};

const sendPasswordResetEmail = async (email: string) => {
  return sendPasswordResetEmailModular(authInstance, email);
};

const clearPersistence = async () => Promise.resolve();

// Auth is the instance (AuthContext uses auth.currentUser). Firestore matches native: firestore().
export { authInstance as auth };
export const firestore = () => firestoreInstance;

export {
  signOut,
  signInWithEmailAndPasswordWeb as signInWithEmailAndPassword,
  sendPasswordResetEmail,
  clearPersistence,
  EmailAuthProvider,
  updateEmail,
  updatePassword,
  reauthenticateWithCredential,
};
export default app;
